import React from 'react';
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import WaterUserContainer from "./WaterUserContainer";

export default () => {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.CENTRAL_ARIZONA],
  };
  return (
    <App isProtected={isProtected} checkRoles={checkRoles}>
      <WaterUserContainer />
    </App>
  );
};